import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';

import { Observable, from, of, concat } from 'rxjs';
import { mergeMap, catchError, timeout, retry, debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
    selector: 'app-info-files',
	templateUrl: './info-files.component.html',
	styleUrls: ['./info-files.component.css']
})
export class InfoFilesComponent extends BaseCrudComponent {

    translations: any;
    base_url:any;
    show_url:any;
    file_obj:any;

    constructor(
        srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService
    ) {
        super(srv, modalService, storage, router);

        this.read_url = '';
        this.create_url = '';
        this.update_url = '';
        this.delete_url = '';
        this.search_fields = ['name'];

        this.base_url = Global.url;
        this.show_url = this.base_url + 'SalesGeneralInformation/File/Download/';
        this.file_obj = {name:'', src: ''};


        this.reload.subscribe(val => {
            if (val) {
                super.clearData();
            }
        });
    }

    ngOnInit() {
        this.translate.getTranslation(this.translate.currentLang)
            .subscribe((translations) => {
                this.translations = translations;
                super.ngOnInit();
                this.rows = [
                	{name: 'Política Comercial', url: 'SalesGeneralInformation/File/Save/CommercialPolicy', code: 'COMMERCIAL', file: null},
                	{name: 'Política de Crédito', url: 'SalesGeneralInformation/File/Save/CreditPolicy', code: 'CREDIT', file: null},
                	{name: 'Política de Reclamos', url: 'SalesGeneralInformation/File/Save/ClaimPolicy', code: 'CLAIM', file: null},
                	{name: 'Política de Garantías', url: 'SalesGeneralInformation/File/Save/WarrantyPolicy', code: 'WARRANTY', file: null},
                	{name: 'Opciones de Cobro', url: 'SalesGeneralInformation/File/Save/CollectOptions', code: 'COLLECT_OPTIONS', file: null},
                	{name: 'Promociones del Mes', url: 'SalesGeneralInformation/File/Save/Promotions', code: 'PROMOTIONS', file: null},
                    {name: 'Incentivos del Mes', url: 'SalesGeneralInformation/File/Save/PromotionsIncentives', code: 'PROMOTIONS_INCENTIVES', file: null},
                    {name: 'Mega Promociones', url: 'SalesGeneralInformation/File/Save/PromotionsMega', code: 'PROMOTIONS_MEGA', file: null},
                    {name: 'Ayuda HiviForce', url: 'SalesGeneralInformation/File/Save/HelpInfo', code: 'HELP', file: null}
                ];

                this.rawdata = this.rows;
            });
    }

    openUpdateModal(content: any, obj: any) {
    	this.update_url = obj.url;
        super.openUpdateModal(content, obj);
    }

    public updateItem(content: any, form: any) {
        var validated = true;

        if (form == undefined) {
            form = {};
        }

        if( (this.file_obj.src == undefined) || (this.file_obj.src == '') ){
        	Swal.fire('No ha seleccionado archivo', '', 'warning');
        	return;
        }

        var to = {file: this.file_obj.src, name: this.file_obj.name};
        var qst = this.update_url;
        this.isUpdating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isUpdating = false;
            if (x.status) {
            	//reset file var
                this.closeModal(content);
                Swal.fire(this.translations['updated'], '', 'success');
            }//end success
            else {
                Swal.fire(x.message, '', 'warning');
                //this.closeModal(content);
            }
        });
    }

    openFile(obj:any){
    	//console.log(obj);
    	//URL.createObjectURL(resp);
    	var myurl = this.show_url + obj['code'];
        window.open(myurl);
    }

    handleInputChange(e, obj:any) {
  	    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
  	    var reader = new FileReader();
  	    
  	    reader.onload = (_event) => { 
  	      this.file_obj.src = reader.result;
  	      this.file_obj.name = file.name;
  	    }

  	    reader.readAsDataURL(file);
  	}

}
